<template>
       <div class="swiper-container">
        <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
            <!--SLIDE-1-->
            <div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Fin de la unidad">
                <div class="container-fluid">
                    <div class="row d-flex justify-content-center margen_principal">
                        <div class="col-lg-8 col-md-12 col-sm-12 col-12 text-center">
                            <h3>¡Has finalizado el estudio del contenido de la unidad <span class="font-italic">Desarrollo cognitivo: teoría de Piaget</span>!</h3>
                        </div>
                    </div>						
                    <div class="row">
                        <div class="col-lg-6 col-md-12 col-sm-12 col-12 offset-lg-3">
                            <div class="row p-4 align-items-center">
                                <div class="col-lg-3 col-md-12 col-sm-12 col-12">
                                    <b-img src="recursos/img/GAVI/Ten_en_cuenta_que.png" class="d-flex mx-auto" fluid alt=""></b-img>
                                    <!-- <img src="../img/GAVI/Ten_en_cuenta_que.png" class="img-fluid d-flex mx-auto" alt=""> -->
                                </div>
                                <div class="col-lg-9 col-md-12 col-sm-12 col-12 mt-lg-0 mt-3">
                                    <!-- <h3 class="px-4 tal"><span class="iconos-i"></span> Ten en cuenta:</h3> -->
                                    <h3 class="px-4 tal"><span class="AlertaFin i-important p-2 text-white iconos-i"></span> Ten en cuenta:</h3>
                                    <div class="ulcheck-Fin mt-3">
                                        <ul class="col01-Uni1">
                                            <li><p>Visitar los recursos audiovisuales y talleres del <span class="font-weight-bold font-italic">material complementario</span> del curso.</p></li>
                                            <li><p>Acceder al acompañamiento de tu docente-tutor.</p></li>
                                            <li><p>Desarrollar las actividades evaluativas formuladas para el curso.</p></li>
                                            <li><p>Socializar las dificultades y buenas prácticas de estudio en los foros temáticos.</p></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row d-flex justify-content-center">
                        <div class="col-lg-8 col-md-12 col-sm-12 col-12 text-center mt-5 mb-5">
                            <h4 class="font-weight-bold">Continúa con el estudio de la siguiente unidad: <span class="font-italic">Aportes de la teoría de Vygotsky al desarrollo cognitivo y psicosocial</span>.</h4>
                            <b-img src="recursos/img/Linea-portada.png" class="d-flex mx-auto my-5" fluid alt=""></b-img>
                            <p class="mt-4">
                                Este documento es propiedad del Instituto Tecnológico Metropolitano (ITM), Institución universitaria adscrita al municipio de Medellín-Colombia. <br>
                                El contenido, metodología didáctica y diseño gráfico están protegidos por las leyes que rigen la propiedad intelectual. <br>
                                Para distribución y uso de todo o parte de este material debe contar con autorización expresa de la Unidad de Educación Virtual ITM.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <!--SLIDE-1-->
        </div>
    </div>
</template>

<script>

import {SwiperController} from '../assets/RecursosITM/js/Swiper'

export default {
    name: 'finUnidad',
    mounted(){
        SwiperController(),
        document.title = this.$route.meta.title
    }
};

</script>